import * as React from 'react';

import {colors} from '../colors/colors';
import type {ColorName} from '../colors/colors';
import {GridList} from '../grid-list/grid-list';
import {Popover} from '../popover/popover';

import styles from './color-swatch-picker.module.css';

export type ColorSwatch = {
    id: string;
    colorName: ColorName;
};

type Props = {
    id?: string;
    colorSwatches: ColorSwatch[];
    selectedSwatch: ColorSwatch;
    onSelectSwatch: (colorSwatch: ColorSwatch) => void;
    buttonSize?: number;
};

export function ColorSwatchPicker(props: Props) {
    const [isPickerOpen, setIsPickerOpen] = React.useState<boolean>(false);

    const buttonRef = React.useRef<HTMLButtonElement | null | undefined>(null);

    return (
        <>
            <button
                // @ts-expect-error
                ref={buttonRef}
                style={{
                    color: colors[props.selectedSwatch.colorName],
                    width: props.buttonSize,
                    height: props.buttonSize,
                }}
                onClick={(event) => {
                    event.stopPropagation();
                    setIsPickerOpen(true);
                }}
                className={styles['color-swatch-button--rounded']}
            />
            {isPickerOpen && (
                <Popover
                    anchor={buttonRef.current}
                    location='top'
                    // @ts-expect-error
                    onClose={() => setIsPickerOpen(false)}
                    onBlur={(event) => {
                        event.stopPropagation();
                        setIsPickerOpen(false);
                    }}
                >
                    <div className='pad-8'>
                        <GridList
                            gridGap={8}
                            numColumns={Math.ceil(props.colorSwatches.length / 2)}
                        >
                            {props.colorSwatches.map((colorSwatch) => (
                                <button
                                    key={colorSwatch.id}
                                    style={{color: colors[colorSwatch.colorName]}}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        props.onSelectSwatch(colorSwatch);
                                        setIsPickerOpen(false);
                                    }}
                                    className={
                                        props.selectedSwatch.id === colorSwatch.id
                                            ? styles['color-swatch-button--selected']
                                            : styles['color-swatch-button']
                                    }
                                />
                            ))}
                        </GridList>
                    </div>
                </Popover>
            )}
        </>
    );
}
